import styled from "styled-components";
import colors from "assets/scss/colors.scss";

const PersonalDetailsWrapper = styled.div`
  background: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  text-align: initial;


  .p-fluid .p-dropdown .p-dropdown-label{
    font-family: 'tawuniya' !important;
  }

  #tele *{
    font-family: 'tawuniya' !important;
    .pi{
      font-family: 'primeicons'!important;
    }
    &.justify-content-between > span{
      margin: 0 0.5rem;
    }
    &.p-inputtext{
      font-family: 'tawuniya' !important;
    }
  }
  #tele {
    ::placeholder{
      font-family: "tawuniya" !important;
    }
  }
  
  .p-dialog-draggable .p-dialog-header {
    border-bottom: 1px solid #000;
  }

  .question_mark {
    position: absolute;
    right: 0.75rem;
    cursor: pointer;
  }

  .visa-icon {
    margin-top: -12px;
  }
  .p-inputtext {
    font-size: 0.9rem;
  }
  .p-input-icon-left > .p-inputtext {
    padding-left: 3rem;
    border: 1px solid #fff;
    &.p-invalid.p-component {
      border-color: #e24c4c;
    }
  }

  .checkbox-wrapper {
    display: flex;
    gap: 1rem;
    label {
    }
  }
  .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {
    border-color: ${colors["bright-purple"]};
    background: ${colors["bright-purple"]};
  }
  .p-checkbox .p-checkbox-box .p-checkbox-icon {
    background: ${colors["bright-purple"]};
  }
  .p-checkbox .p-checkbox-box.p-highlight {
    border-color: ${colors["bright-purple"]};
    background: ${colors["bright-purple"]};
    &.hover {
      border-color: ${colors["bright-purple"]};
    }
  }
  .field {
    input,
    .p-dropdown {
      box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
      border: none;
    }
  }
  .header {
    color: #4c565c;
    & > h5 {
      color: #1a1c1f;
      font-weight: 800;
      font-size: 1.1rem;
      margin-bottom: 10px;
    }
    & > p {
      font-size: 0.9rem;
      color: #4c565c;
    }
  }
  & > form {
    background: #f2f3f5;
    padding: 24px;
    border-radius: 5px;
  }

  .phone-input {
    .keys {
      width: 28%;
      border-radius: 5px 0 0 5px;
      background: #f2f3f5;
      .p-dropdown-trigger-icon {
        font-size: 0.75rem;
        font-weight: bold;
      }
    }
    .values {
      width: 85%;
      border-radius: 0 5px 5px 0;
    }
  }

  .p-float-label input:-webkit-autofill ~ label{
    top: -0.75rem;
  }
  .p-float-label input:focus ~ label, .p-float-label input.p-filled ~ label, .p-float-label textarea:focus ~ label, .p-float-label textarea.p-filled ~ label, .p-float-label .p-inputwrapper-focus ~ label, .p-float-label .p-inputwrapper-filled ~ label {
    top: 0.6rem !important;
    font-size: 12px;
    font-weight: 800;
  }

  .p-input-icon-left.p-float-label > label{
    left: 3rem;
  }

  
  
  &.ar{
    font-family: "tawuniya";
    label, small, h5, p {
      font-family: "tawuniya";
    }
    .p-input-icon-left.p-float-label > label{
      left: auto;
      right: 0.75rem;
    }
    .p-message-close.p-link{
      margin-left:0;
      margin-right:auto;
    }

    .p-input-icon-left > svg:first-of-type {
      top: 1.2rem;
      right: 1rem;
      left: auto;
    }
    *{
      font-family: "tawuniya" !important;
    }
    .field input.fm-tawuniya{
      &::placeholder{
        font-family: "tawuniya" !important;
      }
    }
  
    .pi {font-family: 'primeicons'!important;}
    .p-input-icon-left > .p-inputtext{
      padding-right: 3.5rem;
    }
    .question_mark {
      left: 0.75rem;
      right: auto;
      transform: scaleX(-1);
    }
    .button-next img{
      transform: scaleX(-1);
    }

    font-family: "tawuniya";
    label, small, h5, p {
      font-family: "tawuniya";
    }
    .p-input-icon-left.p-float-label > label{
      left: auto;
      right: 3rem;
    }
    *{
      font-family: "tawuniya" !important;
    }
    .pi {font-family: 'primeicons'!important;}
    .p-input-icon-left > .p-inputtext{
      padding-right: 3.5rem;
    }
    .field input.fm-tawuniya, .p-dropdown.fm-tawuniya, .field .fm-tawuniya.p-inputtext
     {
        &::placeholder{
          font-family: "tawuniya" !important;
        }
      }
  
      .fm-tawuniya{
        font-family: 'tawuniya' !important;
      }
  
    .field .fm-tawuniya.p-inputtext.p-filled, 
    .field .fm-tawuniya.p-inputtext.p-dropdown-label,
    .field .fm-tawuniya.p-inputtext.p-dropdown-label span
    {
      font-family: 'tawuniya' !important;
    }
    .question_mark {
      left: 0.75rem !important;
      right: auto !important;
      transform: scaleX(-1) !important;
    }
    .p-accordion-content{
      .personal-details-head p{
        margin-right: 0.5rem;
      }
    }
    .p-input-icon-left > svg:first-of-type {
      top: 1.2rem;
      right: 1rem;
      left: auto;
    }
    .p-calendar-w-btn-left .p-datepicker-trigger {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    .p-calendar-w-btn-left .p-inputtext {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .button-next img{
      transform: scaleX(-1);
    }
    button.p-button.p-component.back.float-right{
        display: inline-flex;
        img{
          transform: scaleX(-1);
        }   
    }
    .p-float-label > label {
      left: auto;
      right: 0.75rem;
    }
    .p-input-icon-left.p-float-label > label{
      left: auto;
      right: 2.7rem;
    }
  }
  }

  .mobile-placeholder {
    position: absolute;
    top: -4px;
    left: 30%;
  }

  @media only screen and (max-width: 576px){
    // .p-tabview-title{
    //   display: none;
    // }

    .mobile-placeholder {
      left: 51%;
    }
    
    .visit-visa-mob {
      margin-top: 0 !important;
    }
    .phone-input {
      .keys {
        width: auto;
        max-width: 7.5rem;
      }
      .values {
        width: 100%;
      }
    }
    .p-float-label label {
      right: 2.75rem;
    }
  
  }
`;

export const TabsWrapper = styled.div`
  .motor-banner-container {
    text-align: center;
  }

  .motor-banner {
    max-width: 100%;
    height: auto;
  }

 &.ar{
  *{
    font-family: "tawuniya" !important;
  }
  .pi {font-family: 'primeicons'!important;}
}
  margin-top: 3rem;
  .p-tabview.p-component {
    border-radius: 1rem;
  }
  .p-tabview .p-tabview-nav {
    border: 0;
    background: transparent;
  }
  .p-tabview .p-tabview-nav li .p-tabview-nav-link{
    background: transparent;
  }
  .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link{
    background: #fff;
    border: 0;
    color: #1A1C1F;
  }

  .p-tabview .p-tabview-nav .p-tabview-ink-bar{
    background: #fff;
  }

  .icon_wrapper{
    path{
      fill: background: #1A1C1F;
    }
  }

  .p-tabview-selected.p-highlight{
    .p-tabview-nav-link{
      display: flex;
      justify-content: space-between;
      gap: 0.5rem;
    }
    .icon_wrapper{
      path{
        fill: #1A1C1F;
      }
    }
  }

  .STC_banner{
  *{
    font-family: 'Tawuniya';
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1rem;
  gap: 1rem;
  background: #4F008C;
  border-radius: 4px;
  color: #FFFFFF;
  .content, .buttons_wrapper{
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    width: 100%;
  }
  h2{
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 130%;
    letter-spacing: -0.03em;
  }
  p{
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 160%;
  }
  .buttons{
    display: flex;
    gap: 1rem;
    width: 100%;
    .btn{
      display: flex;
      flex-grow: 1;
      flex-basis: 0;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 7px 12px 10px;
      gap: 4px;
      background: #FFFFFF;
      border-radius: 2px;
      p{
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 12px;
        text-align: center;
        color: #4F008C;
      }
      small{
        font-style: normal;
        font-weight: 400;
        font-size: 10px;
        line-height: 10px;
        text-align: center;
        color: #8966A4;
      }
      &.active{
        *{
          color: #FFFFFF;
        }
        background: #FF375E;
        border-color: #FF375E;
      }
    }
  }
  .accordion_wrapper{
    display: block;
    width: 100%;
    .p-accordion-header{
      display:none;
    }
    .p-accordion-content{
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      background: #4F008C;
      color: #FFFFFF;
      padding: 0 !important;
    }
    .feature{
      display: flex;
      width: 100%;
      gap: 0.75rem;
      color: #fff;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      svg{
        width: 18.33px;
        min-width: 18.33px;
      }
    }
  }
}

  @media only screen and (max-width: 576px){
    
    .p-tabview-selected.p-highlight{
      .p-tabview-nav-link{
        display: flex;
        justify-content: space-between;
        gap: 0.5rem;
      }
      .icon_wrapper{
        position: relative;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 0.45rem;
        background: #6b47f5;
        border-radius: 50%;
        width: 2rem;
        height: 2rem;
        svg{
          position: absolute;
        }
        path{
          fill: #fff;
        }
      }
    }
  }

 `;

export default PersonalDetailsWrapper;
